// Sincronizado con apps/api/src/features/tasks/schemas.ts ingestSchema.source
// + packages/db enum task_source. 'bot_camila' agregado en Sprint
// Auth-for-Bots (migration 0009 — orquestador omnichannel).
// 'portal' agregado en migration 0105 — tickets del Portal Cliente.
export const TASK_SOURCES = [
  'manual',
  'bot_whatsapp',
  'bot_email',
  'bot_sii',
  'bot_scotiabank',
  'bot_camila',
  'automation',
  'api',
  'portal',
] as const;
export type TaskSource = (typeof TASK_SOURCES)[number];

export const TASK_SOURCE_LABELS: Record<TaskSource, string> = {
  manual: 'Manual',
  bot_whatsapp: 'Bot WhatsApp',
  bot_email: 'Bot Email',
  bot_sii: 'Bot SII',
  bot_scotiabank: 'Bot Scotiabank',
  bot_camila: 'Bot Camila',
  automation: 'Automatización',
  api: 'API',
  portal: 'Portal',
};

// Sources que muestran badge en card. 'manual' es excluido — no badge.
export const SOURCES_WITH_BADGE: ReadonlySet<TaskSource> = new Set([
  'bot_whatsapp',
  'bot_email',
  'bot_sii',
  'bot_scotiabank',
  'bot_camila',
  'automation',
  'api',
  'portal',
]);
